import React, { useEffect, useState } from 'react';
import { fetchData, postData } from '../components/misc';

const formatTime = (task) => {
    let ts = Number(task.time);
    if (isNaN(ts)) {
        ts = Number(task.time_str);
    }
    if (!isNaN(ts)) {
        const d = new Date(ts * 1000);
        const pad = n => String(n).padStart(2, '0');
        const dd = pad(d.getDate());
        const mm = pad(d.getMonth() + 1);
        const yy = d.getFullYear().toString().slice(-2);
        const hh = pad(d.getHours());
        const min = pad(d.getMinutes());
        return `${dd}/${mm}/${yy} ${hh}:${min}`;
    }
    return task.time_str || '';
};

export default function MessageTasksDashboard() {
    const [users, setUsers] = useState([]);
    const [expanded, setExpanded] = useState({});
    const [tasks, setTasks] = useState({});

    useEffect(() => {
        load();
    }, []);

    const load = () => {
        fetchData('/api/sirri_api/message_task_users')
            .then(data => {
                if (data.responsecode === 200) {
                    setUsers(data.users);
                }
            })
            .catch(err => console.error('Failed to load users', err));
    };

    const fetchTasks = (email) => {
        fetchData(`/api/sirri_api/tasks/${email}`)
            .then(data => {
                if (data.responsecode === 200) {
                    setTasks(prev => ({ ...prev, [email]: data.tasks || [] }));
                } else {
                    setTasks(prev => ({ ...prev, [email]: [] }));
                }
            })
            .catch(err => console.error('Failed to load tasks', err));
    };

    const toggle = (email) => {
        setExpanded(prev => {
            const next = !prev[email];
            if (next && !tasks[email]) {
                fetchTasks(email);
            }
            return { ...prev, [email]: next };
        });
    };

    const clearUser = (email) => {
        postData('/api/sirri_api/clear_message_tasks', { email })
            .then(() => {
                setUsers(prev => prev.filter(u => u.email !== email));
                setTasks(prev => { const n = { ...prev }; delete n[email]; return n; });
                setExpanded(prev => { const n = { ...prev }; delete n[email]; return n; });
            })
            .catch(err => console.error('Failed to clear tasks', err));
    };

    const runOne = (email, index) => {
        postData('/api/sirri_api/run_task', { email, index })
            .then(res => {
                alert(`Response code: ${res.responsecode}`);
                if (res.responsecode === 200) {
                    fetchTasks(email);
                }
            })
            .catch(err => {
                alert('Failed to run task');
                console.error('Failed to run task', err);
            });
    };

    return (
        <div className="space-y-2">
            {users.map((u, idx) => (
                <div key={idx} className="bg-gray-800 text-white p-2 rounded">
                    <div className="flex items-center space-x-2">
                        <button
                            className="font-bold"
                            onClick={() => toggle(u.email)}
                        >
                            {expanded[u.email] ? '-' : '+'}
                        </button>
                        <span>{u.name} - {u.email} ({u.tasks})</span>
                        <button className="bg-red-700 px-2 py-1" onClick={() => clearUser(u.email)}>Clear</button>
                    </div>
                    {expanded[u.email] && (
                        <div className="ml-6 mt-2 space-y-1">
                            {(tasks[u.email] || []).map((t, i) => (
                                <div key={i} className="flex items-center space-x-2 text-sm">
                                    <span>{t.man.fullname1} - {t.message} ({formatTime(t)})</span>
                                    <button className="bg-blue-700 px-1" onClick={() => runOne(u.email, i)}>Run</button>
                                </div>
                            ))}
                            {(!tasks[u.email] || tasks[u.email].length === 0) && <p className="text-sm">No tasks.</p>}
                        </div>
                    )}
                </div>
            ))}
            {users.length === 0 && <p className="text-white">No users</p>}
        </div>
    );
}
